// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
::after,
::before {
  box-sizing: border-box;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}

.row {
  margin-left: auto;
  margin-right: auto;
}

.fa {
  display: inline-block;
  font: 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fa-plus-circle {
  font-size: 20px;
  color: #2a62ff;
}

.fa-plus-circle:before {
  content: "\\f055";
}

.fa-minus-circle {
  font-size: 20px;
  color: #2a62ff;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.border-bottom {
  font-weight: 400;
  height: 50px;
  border-top-width: 2px !important;
}

.border-bottom1 {
  font-weight: 400;
  border-top-width: 2px !important;
}

.border-fillColor {
  background-color: rgb(230, 249, 255);
  color: rgb(47, 51, 65);
}

.border-fillColor1 {
  background-color: white;
  color: rgb(47, 51, 65);
}

.messageFont {
  font-family: Poppins, sans-serif !important;
}

.messageFont1 {
  font-family: "montserratbold", Arial, Helvetica, sans-serif;
}

.messageCount {
  width: 22%;
  padding-top: 3px;
  font-weight: 500;
  margin-left: 10px;
  top: 5px;
}

.btnbgColor1 {
  width: 15%;
  background-color: coral;
  color: #fff;
  border: coral;
  box-shadow: 0 0 0 0.05rem coral;
  margin-left: 10px;
  height: 25px;
  border-radius: 50px;
}

.btn-link {
  width: 15%;
  height: 25px;
  border-radius: 50px;
  text-decoration: none;
  margin-left: 10px;
}

.msg-page .d-block .card1 {
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.breadcrumb,
.card1 {
  background-color: var(--foreground-secondary) !important;
  border-radius: 7px !important;
}

.card1 {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c8ced3;
}

.message-contain .card-body1 {
  padding: 0.2rem 1.25rem;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-top: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media only screen and (max-width: 760px) {
  .messageCount {
    width: 33%;
    padding-top: 7px;
    font-weight: 500;
    margin-left: 10px;
    top: 5px;
  }
  .btnbgColor1 {
    width: 22%;
    background-color: coral;
    color: #fff;
    border: coral;
    box-shadow: 0 0 0 0.05rem coral;
    margin-left: 10px;
    height: 25px;
    border-radius: 50px;
  }
  .btn-link {
    width: 22%;
    height: 25px;
    border-radius: 50px;
    text-decoration: none;
    margin-left: 10px;
  }
}
.message-details:hover {
  color: #fff;
  border-color: #598bff;
  background-color: #598bff;
}

.message-details {
  position: relative;
  background-color: #fff;
  color: #598bff;
  border-color: #598bff;
  box-shadow: none;
  min-height: 34px;
  width: 25%;
  border-radius: 5px;
}

.modal-footer-center {
  display: flex;
  justify-content: center;
}

.messages_noData {
  padding-bottom: 30px;
  line-height: 0.5 !important;
}

.nodataclass {
  width: 40%;
  height: 425px;
  margin: 20px;
}

@media only screen and (max-width: 900px) {
  .nodataclass {
    width: 80%;
    height: 425px;
    margin: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/Notifications/messages/messages.component.scss"],"names":[],"mappings":"AAAA;;;EAGE,sBAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AACA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;AAAF;;AAGA;EACE,gBAAA;EACA,gCAAA;AAAF;;AAGA;EACE,oCAAA;EACA,sBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,2CAAA;AAAF;;AAGA;EACE,2DAAA;AAAF;;AAGA;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;AAAF;;AAGA;EACE,UAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,qDAAA;EACA,oCAAA;AAAF;;AAGA;;EAEE,wDAAA;EACA,6BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE;IACE,UAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,QAAA;EAAF;EAGA;IACE,UAAA;IACA,uBAAA;IACA,WAAA;IACA,aAAA;IACA,+BAAA;IACA,iBAAA;IACA,YAAA;IACA,mBAAA;EADF;EAIA;IACE,UAAA;IACA,YAAA;IACA,mBAAA;IACA,qBAAA;IACA,iBAAA;EAFF;AACF;AAKA;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;;AAMA;EACE,oBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,UAAA;EACA,aAAA;EACA,YAAA;AAHF;;AAMA;EACE;IACE,UAAA;IACA,aAAA;IACA,YAAA;EAHF;AACF","sourcesContent":["*,\r\n::after,\r\n::before {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.row {\r\n  --bs-gutter-x: 1.5rem;\r\n  --bs-gutter-y: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-top: calc(var(--bs-gutter-y) * -1);\r\n  margin-right: calc(var(--bs-gutter-x) * -0.5);\r\n  margin-left: calc(var(--bs-gutter-x) * -0.5);\r\n}\r\n\r\n.row {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.fa {\r\n  display: inline-block;\r\n  font: 14px / 1 FontAwesome;\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.fa-plus-circle {\r\n  font-size: 20px;\r\n  color: #2a62ff;\r\n}\r\n\r\n.fa-plus-circle:before {\r\n  content: '\\f055';\r\n}\r\n\r\n.fa-minus-circle {\r\n  font-size: 20px;\r\n  color: #2a62ff;\r\n}\r\n.text-truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  //   background-color: rgb(230, 249, 255);\r\n  //   color: rgb(47, 51, 65);\r\n}\r\n\r\n.border-bottom {\r\n  font-weight: 400;\r\n  height: 50px;\r\n  border-top-width: 2px !important;\r\n}\r\n\r\n.border-bottom1 {\r\n  font-weight: 400;\r\n  border-top-width: 2px !important;\r\n}\r\n\r\n.border-fillColor {\r\n  background-color: rgb(230, 249, 255);\r\n  color: rgb(47, 51, 65);\r\n}\r\n\r\n.border-fillColor1 {\r\n  background-color: white;\r\n  color: rgb(47, 51, 65);\r\n}\r\n\r\n.messageFont {\r\n  font-family: Poppins, sans-serif !important;\r\n}\r\n\r\n.messageFont1 {\r\n  font-family: 'montserratbold', Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.messageCount {\r\n  width: 22%;\r\n  padding-top: 3px;\r\n  font-weight: 500;\r\n  margin-left: 10px;\r\n  top: 5px;\r\n}\r\n\r\n.btnbgColor1 {\r\n  width: 15%;\r\n  background-color: coral;\r\n  color: #fff;\r\n  border: coral;\r\n  box-shadow: 0 0 0 0.05rem coral;\r\n  margin-left: 10px;\r\n  height: 25px;\r\n  border-radius: 50px;\r\n}\r\n\r\n.btn-link {\r\n  width: 15%;\r\n  height: 25px;\r\n  border-radius: 50px;\r\n  text-decoration: none;\r\n  margin-left: 10px;\r\n}\r\n\r\n.msg-page .d-block .card1 {\r\n  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.breadcrumb,\r\n.card1 {\r\n  background-color: var(--foreground-secondary) !important;\r\n  border-radius: 7px !important;\r\n}\r\n\r\n.card1 {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 1px solid #c8ced3;\r\n}\r\n\r\n.message-contain .card-body1 {\r\n  padding: 0.2rem 1.25rem;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n  margin-top: 15px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n@media only screen and (max-width: 760px) {\r\n  .messageCount {\r\n    width: 33%;\r\n    padding-top: 7px;\r\n    font-weight: 500;\r\n    margin-left: 10px;\r\n    top: 5px;\r\n  }\r\n\r\n  .btnbgColor1 {\r\n    width: 22%;\r\n    background-color: coral;\r\n    color: #fff;\r\n    border: coral;\r\n    box-shadow: 0 0 0 0.05rem coral;\r\n    margin-left: 10px;\r\n    height: 25px;\r\n    border-radius: 50px;\r\n  }\r\n\r\n  .btn-link {\r\n    width: 22%;\r\n    height: 25px;\r\n    border-radius: 50px;\r\n    text-decoration: none;\r\n    margin-left: 10px;\r\n  }\r\n}\r\n\r\n.message-details:hover {\r\n  color: #fff;\r\n  border-color: #598bff;\r\n  background-color: #598bff;\r\n}\r\n\r\n.message-details {\r\n  position: relative;\r\n  background-color: #fff;\r\n  color: #598bff;\r\n  border-color: #598bff;\r\n  box-shadow: none;\r\n  min-height: 34px;\r\n  width: 25%;\r\n  border-radius: 5px;\r\n}\r\n\r\n.modal-footer-center {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.messages_noData {\r\n  padding-bottom: 30px;\r\n  line-height: 0.5 !important;\r\n}\r\n\r\n.nodataclass {\r\n  width: 40%;\r\n  height: 425px;\r\n  margin: 20px;\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n  .nodataclass {\r\n    width: 80%;\r\n    height: 425px;\r\n    margin: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
